import goggles from 'common/onboarding/immersive-onboarding-legacy/assets/goggles.webp';
import exploreNoEvents from 'common/onboarding/immersive-onboarding-legacy/assets/explore-no-events.webp';
import exploreCongratulations from 'common/onboarding/immersive-onboarding-legacy/assets/explore-congratulations.webp';
import companyKpisTemplate from 'common/onboarding/immersive-onboarding-legacy/assets/company_kpis_template.webp';
import featureLaunchTemplate from 'common/onboarding/immersive-onboarding-legacy/assets/feature_launch_template.webp';
import lifecycleCohortTemplate from 'common/onboarding/immersive-onboarding-legacy/assets/lifecycle_cohort_template.webp';
import marketingKpisTemplate from 'common/onboarding/immersive-onboarding-legacy/assets/marketing_kpis_template.webp';
import webAnalyticsTemplate from 'common/onboarding/immersive-onboarding-legacy/assets/web_analytics_template.webp';
import bannerImage from 'common/onboarding/immersive-onboarding-legacy/assets/events-banner-thumbnail.webp';
import friendlyX from 'common/onboarding/immersive-onboarding-legacy/assets/friendly-x.webp';
import welcomeCompanies from 'common/onboarding/immersive-onboarding-legacy/assets/welcome-companies.webp';
import welcomeDemo from 'common/onboarding/immersive-onboarding-legacy/assets/welcome-demo.webp';
import toggles from 'common/onboarding/immersive-onboarding-legacy/assets/toggles.webp';
import sendData from 'common/onboarding/immersive-onboarding-legacy/assets/send-data.webp';
import bq from 'common/onboarding/immersive-onboarding-legacy/assets/bq.svg';
import gtm from 'common/onboarding/immersive-onboarding-legacy/assets/googletag.svg';
import rudderstack from 'common/onboarding/immersive-onboarding-legacy/assets/rudderstack.svg';
import snowflake from 'common/onboarding/immersive-onboarding-legacy/assets/snowflake.svg';
import segment from 'common/onboarding/immersive-onboarding-legacy/assets/segment.svg';
import more from 'common/onboarding/immersive-onboarding-legacy/assets/more.svg';
import js from 'common/onboarding/immersive-onboarding-legacy/assets/JS.svg';
import android from 'common/onboarding/immersive-onboarding-legacy/assets/android.svg';
import ios from 'common/onboarding/immersive-onboarding-legacy/assets/iOS.svg';
import eventListenerGif from 'common/onboarding/immersive-onboarding-legacy/assets/events-heart-beat.gif';
import eventDetected from 'common/onboarding/immersive-onboarding-legacy/assets/events-detected.svg';
import checkmark from 'common/onboarding/immersive-onboarding-legacy/assets/checkmark.svg';
import spot from 'common/onboarding/immersive-onboarding-legacy/assets/spot.webp';
import readyToConnect from 'common/onboarding/immersive-onboarding-legacy/assets/ready-to-connect-v2.riv';
import demoVideoThumbnail from 'common/onboarding/immersive-onboarding-legacy/assets/demo-video-thumbnail@2x.webp';
import wave from 'common/onboarding/immersive-onboarding-legacy/assets/wave.riv';
import tableHeaderGradient from 'common/onboarding/immersive-onboarding-legacy/assets/table-header-gradient.webp';
import summaryCheckmark from 'common/onboarding/immersive-onboarding-legacy/assets/summary-checkmark.webp';
import duplicate from 'common/onboarding/immersive-onboarding-legacy/assets/duplicate.svg';
import help from 'common/onboarding/immersive-onboarding-legacy/assets/help.svg';
import personalizeStepGradient from 'common/onboarding/immersive-onboarding-legacy/assets/personalize-step-gradient.webp';
import connectDataGradient from 'common/onboarding/immersive-onboarding-legacy/assets/connect-data-gradient.webp';
import ligthningBolt from 'common/onboarding/immersive-onboarding-legacy/assets/lightning-bolt.webp';
import clipboardCheckboxes from 'common/onboarding/immersive-onboarding-legacy/assets/clipboard-checkboxes.webp';
import reactNative from 'common/onboarding/immersive-onboarding-legacy/assets/react-native.svg';
import redshift from 'common/onboarding/immersive-onboarding-legacy/assets/redshift.svg';
import eventListener from 'common/onboarding/immersive-onboarding-legacy/assets/live-data.riv';

export const IMMERSIVE_ASSETS = {
  bannerImage,
  friendlyX,
  welcomeCompanies,
  welcomeDemo,
  toggles,
  goggles,
  exploreNoEvents,
  exploreCongratulations,
  companyKpisTemplate,
  featureLaunchTemplate,
  lifecycleCohortTemplate,
  marketingKpisTemplate,
  webAnalyticsTemplate,
  sendData,
  bq,
  gtm,
  rudderstack,
  snowflake,
  segment,
  more,
  js,
  android,
  ios,
  eventListenerGif,
  eventDetected,
  checkmark,
  spot,
  readyToConnect,
  demoVideoThumbnail,
  wave,
  tableHeaderGradient,
  summaryCheckmark,
  duplicate,
  help,
  personalizeStepGradient,
  connectDataGradient,
  ligthningBolt,
  clipboardCheckboxes,
  reactNative,
  redshift,
  eventListener,
};
